import React from 'react';

import { useIntl } from 'react-intl';

import { ToggleFilter } from '../../../../../common/ui/filters/toggle-filter';
import { useBooleanFilter } from '../../../../../controllers/filters/boolean-filter';
import { filter as titleMatchOnlyFilter } from '../../../../../controllers/store/search/filters/title-match-only';
import { i18n } from './messages';

type TitleMatchOnlyFilterProps = {
	isFilterInDropdown?: boolean;
};

const TitleMatchOnlyFilter = ({
	isFilterInDropdown = false,
}: TitleMatchOnlyFilterProps): React.JSX.Element | null => {
	const { formatMessage } = useIntl();

	const [state, { toggle }] = useBooleanFilter({
		filterId: titleMatchOnlyFilter.id,
	});

	if (!state) {
		return null;
	}

	const { value, autoFocus } = state;

	return (
		<ToggleFilter
			onChange={toggle}
			isChecked={value}
			autoFocus={autoFocus}
			isFilterInDropdown={isFilterInDropdown}
		>
			{formatMessage(i18n.onlyTitleMatch)}
		</ToggleFilter>
	);
};

export default TitleMatchOnlyFilter;
